import React from 'react'

const BalanceBody = ({ item }) => {
    const { Sno, memberMobile, pkgGroup, pkg, sDate, eDate, totalFee, remaingBalance } = item;

    return (
        <tbody>
            <tr className="border-b hover:bg-gray-100 animation">
                <td className="table_body border-r">
                    {Sno}
                </td>
                <td className="table_body border-r">
                    {memberMobile}
                </td>
                <td className="table_body border-r">
                    {pkgGroup}
                </td>
                <td className="table_body border-r">
                    {pkg}
                </td>
                <td className="table_body border-r">
                    {sDate}
                </td>
                <td className="table_body border-r">
                    {eDate}
                </td>
                <td className="table_body border-r">
                    {totalFee}
                </td>
                <td className="table_body border-r">
                    {remaingBalance}
                </td>
            </tr>
        </tbody>
    )
}

export default BalanceBody;